import Select from 'react-select';

export function FormikSelect({options, field, form, placeholder, isDisabled}) {
      return (
        <Select
          name={field.name}
          onBlur={field.onBlur}
          onChange={({ value }) => form.setFieldValue(field.name, value)}
          options={options}
          placeholder={placeholder}
          isDisabled={isDisabled}
          value={(options ? options.find(option => option.value === field.value) : '')}
          className={`text-center input-color`}
          styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderRadius:"20px",
                borderColor: form.errors[field.name] && form.touched[field.name]? "#ff0000":"#ced4da",
                color:"#0A66C2"
              }),
              singleValue: (base) => ({
                  ...base,
                  color: '#0A66C2',
                }),
            }}
        />
      );
    }